'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const ReactPlayer = dynamic(() => import('react-player/lazy'), {
    ssr: false,
});

const VideoPlayer: React.FC<{ url?: string }> = ({ url }) => {
    const [hasWindow, setHasWindow] = React.useState(false);

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            setHasWindow(true);
        }
    }, []);
    return <>{hasWindow && url && <ReactPlayer url={url} />}</>;
};

export default VideoPlayer;
